import { render, staticRenderFns } from "./previus-edit-modal.vue?vue&type=template&id=e677b55e"
import script from "./previus-edit-modal.vue?vue&type=script&lang=js"
export * from "./previus-edit-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports